module.exports = __webpack_public_path__ + "static/media/icon-google-plus.996ade42.svg";